<ng-template #indicatorTemplate><ui-icon iconType="loading" class="busy-indicator-progress-color"></ui-icon></ng-template>

<div>Small : <ui-spin spinSimple spinSize="small" [spinIndicator]="indicatorTemplate"></ui-spin></div>
<div>Default : <ui-spin spinSimple [spinIndicator]="indicatorTemplate"></ui-spin></div>
<div>Large : <ui-spin spinSimple spinSize="large" [spinIndicator]="indicatorTemplate"></ui-spin></div>
